/**
 * FleetTrack tracking-session status domain.
 *
 * `tracking_sessions.status` is a plain varchar — this module is the single
 * source of truth for its value set so every reader (REST state machine,
 * socket guards, active-session filters, admin/public UIs) agrees on which
 * statuses are terminal. A terminal session must never transition again:
 * 'ended' means "completed normally", 'cancelled' means "aborted by ops".
 *
 * Keep this file dependency-free — it is consumed by the server, the admin
 * client, and client-public (which builds in isolation on Vercel).
 */
export const TRACKING_SESSION_STATUSES = [
  "created",
  "boarding",
  "in_transit",
  "ended",
  "cancelled",
] as const;

export type TrackingSessionStatus = (typeof TRACKING_SESSION_STATUSES)[number];

export const TERMINAL_TRACKING_STATUSES = ["ended", "cancelled"] as const;

export type TerminalTrackingStatus =
  (typeof TERMINAL_TRACKING_STATUSES)[number];

export function isTerminalTrackingStatus(
  status: string,
): status is TerminalTrackingStatus {
  return (TERMINAL_TRACKING_STATUSES as readonly string[]).includes(status);
}

/**
 * Maximum inclusive day span for the explicit from/to history filter on
 * GET /api/tracking/sessions — same 92-day cap the trips endpoints enforce
 * via MAX_TRIP_RANGE_DAYS (server/utils/trip-range.ts). Shared so the admin
 * UI can reject an over-long draft range before submitting instead of
 * surfacing a server 400.
 */
export const SESSION_LIST_MAX_RANGE_DAYS = 92;
